import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-panoramic-xray',
  templateUrl: './panoramic-xray.component.html',
  styleUrls: ['./panoramic-xray.component.scss']
})
export class PanoramicXrayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
